<template>
  <div id="ms-popover-in-component-container" class="ms-popover-in-component-container" />
</template>

<style lang="scss" scoped>
.ms-popover-in-component-container {
  position: fixed;
  z-index: 101;
}
</style>